import { axiosInstance } from "..";
import { LocalStorageKey } from "utils";

const getAuthHeaders = (): Record<string, string> => {
	const token = localStorage.getItem(LocalStorageKey);
	return token ? { Authorization: token } : {};
};

export const reactions = {
	toggle: (payload: {
		reactable_type: string;
		reactable_id: number;
		reaction_type: string;
	}) =>
		axiosInstance().post("/reactions", {
			reactable_type: payload.reactable_type,
			reactable_id: payload.reactable_id,
			reaction_type: payload.reaction_type,
		}, { headers: getAuthHeaders() }),
	getReactors: (params: {
		reactable_type: string;
		reactable_id: number;
		reaction_type?: string;
		page?: number;
		limit?: number;
	}) =>
		axiosInstance().get("/reactions/users", { params, headers: getAuthHeaders() }),
};
